import React from 'react'
import { Cell, Flex } from '../../styles/styled-common'
import { currencySymbolByCode } from '../../utils'

export default class SlotsPriceCell extends React.PureComponent {
  render() {
    const { price, slots, currency, ...props } = this.props
    const symb = currencySymbolByCode(currency)
    const priceMax = price.max.toFixed(2)
    const priceMin = price.min.toFixed(2)

    return (
      <Cell {...props} alignItems="flex-end" justifyContent="space-around">
        <Flex flexDirection="column" alignItems="flex-start">
          <div>Price</div>
          <div>Slots</div>
        </Flex>
        <Flex flexDirection="column" alignItems="flex-end">
          <div>
            {symb}
            {priceMax}
          </div>
          <div>{slots.min}</div>
        </Flex>
        <Flex flexDirection="column" alignItems="flex-end">
          <div>
            {symb}
            {priceMin}
          </div>
          <div>{slots.max}</div>
        </Flex>
      </Cell>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cells/SlotsPriceCell.jsx